import React, { useContext } from "react";
import { useParams } from "react-router-dom";

import CONSTANT from "../../constants/Constant";
import MobileHeader from "../shared/layout/MobileHeader";
import MainHeaderWrapper from "../shared/layout/HeadWrappers/MainHeaderWrapper";
import Footer from "../shared/layout/Footer";
import MyExercisesDetails from "./MyExercisesDetails";
// import BodyWithLeftMenu from "../shared/layout/BodyWithLeftMenu";
import AppContext from "../../contexts/AppContext";
import MyExcercisesList from "./MyExcercisesList";
import BodyWithTopMenu from "../shared/layout/BodyWithTopMenu";

const MyExercises = () => {
    const { userInfo } = useContext(AppContext);
    const { EnableFysicalScore, IsPostureAnalyzeEnabled } = userInfo.Permissions;
    let { testId } = useParams();

    return (
        <>
            {/*<MobileHeader/>*/}
            <div>
                <MainHeaderWrapper/>
                {!EnableFysicalScore && IsPostureAnalyzeEnabled && (
                    <MyExcercisesList />
                )}
                {EnableFysicalScore && (
                    <>
                        <BodyWithTopMenu pageName={CONSTANT.PAGE_NAME.MY_EXERCISES}>
                            <MyExcercisesList />
                        </BodyWithTopMenu>
                        <Footer/>
                    </>
                )}
            </div>
        </>
    )
};

export default MyExercises;
